var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#5C5E69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13C21 13 18 7.5 13 7.5C8 7.5 5 13 5 13C5 13 8 18.5 13 18.5C18 18.5 21 13 21 13ZM6.1727 13C6.22963 12.9132 6.29454 12.8168 6.36727 12.7124C6.70216 12.2319 7.19631 11.5929 7.83211 10.9571C9.12103 9.66818 10.8806 8.5 13 8.5C15.1194 8.5 16.879 9.66818 18.1679 10.9571C18.8037 11.5929 19.2978 12.2319 19.6327 12.7124C19.7055 12.8168 19.7704 12.9132 19.8273 13C19.7704 13.0868 19.7055 13.1832 19.6327 13.2876C19.2978 13.7681 18.8037 14.4071 18.1679 15.0429C16.879 16.3318 15.1194 17.5 13 17.5C10.8806 17.5 9.12103 16.3318 7.83211 15.0429C7.19631 14.4071 6.70216 13.7681 6.36727 13.2876C6.29454 13.1832 6.22963 13.0868 6.1727 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5C11.6193 10.5 10.5 11.6193 10.5 13C10.5 14.3807 11.6193 15.5 13 15.5C14.3807 15.5 15.5 14.3807 15.5 13C15.5 11.6193 14.3807 10.5 13 10.5ZM9.5 13C9.5 11.067 11.067 9.5 13 9.5C14.933 9.5 16.5 11.067 16.5 13C16.5 14.933 14.933 16.5 13 16.5C11.067 16.5 9.5 14.933 9.5 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEyeIcon);
export default __webpack_public_path__ + "static/media/dark-eye-icon.4ddb10a58d2c182ae4df788a350085bb.svg";
export { ForwardRef as ReactComponent };